import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { Reparti } from 'src/app/models/reparti';
import { environment } from '../../../environments/environment';
import notify from 'devextreme/ui/notify';
@Injectable({
  providedIn: 'root'
})
export class RepartiService {
  private http = inject(HttpClient);


  repartiUrl = environment.ildatoArticoliDpi + 'api/reparti';

  private _listReparti = new BehaviorSubject<Reparti[] | undefined>(undefined);

  list(): Observable<Reparti[]> {
    return this.http.get<Reparti[]>(this.repartiUrl);
  }

  listTemp(forceRefresh: boolean = false): Observable<Reparti[]>{
    if (
      this._listReparti.value == undefined ||
      forceRefresh
    ) {
      this.http.get<Reparti[]>(this.repartiUrl).subscribe({
        next: (res) => {
          this._listReparti.next(res);
        },
        error: (err) => {
          if (err?.error?.title) {
            notify(err.error.title, 'error');
          } else {
            notify('Errore recupero lista categorie articoli', 'error');
          }
        },
      });
    }
    return this._listReparti.asObservable().pipe(filter((r) => r != null));
  }

  get(id:number): Observable<Reparti> {
    return this.http.get<Reparti>(this.repartiUrl  + '/'+ id);
  }

  insert(values: Reparti): Observable<Reparti> {
    return this.http.post<Reparti>(this.repartiUrl, values);
  }

  remove(idReparto: number): Observable<Reparti> {
    return this.http.delete<Reparti>(this.repartiUrl + '/'+ idReparto );
  }

  update(key: number, values: Reparti): Observable<Reparti> {
    return this.http.put<Reparti>(this.repartiUrl + '/'+ key , values);
  }

  cleanTemp(){
    this._listReparti.next(undefined);
  }
}
